import React from "react";

export default function ComingSoonInline({ icon: Icon, title, description }) {
  return (
    <div className="card-elevated p-10 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-accent/10 text-accent">
        <Icon className="h-6 w-6" />
      </div>
      <div className="mt-4 text-[10px] font-bold uppercase tracking-[0.25em] text-accent">Prochainement</div>
      <h2 className="mt-2 font-serif text-2xl">{title}</h2>
      <p className="mt-3 text-muted-foreground max-w-lg mx-auto leading-relaxed">{description}</p>
    </div>
  );
}
